import { Playground } from '../design-system/playground';

const devPaths =
  process.env.NODE_ENV !== 'production'
    ? [{ path: ':countryCode/playground', component: Playground }]
    : [];

export const commonRoutePaths = [...devPaths];
